export const setModerUI = (payload) => ({
  type: 'MOD_UI_IS_VISIBLE',
  payload,
})

export const setProfileTitle = (string) => ({
  type: 'SET_PROFILE_TITLE',
  payload: string,
})

export function setIsSocketConnectedAction(status) {
  return {
    type: 'SET_IS_SOCKET_CONNECTED',
    payload: { status },
  }
}

export const setSurveyStatusAction = (hasSurvey) => ({
  type: 'UI_SET_SURVEY_STATUS',
  payload: { hasSurvey },
})

export const setSurveyDataAction = (surveyData) => ({
  type: 'UI_SET_SURVEY_DATA',
  payload: surveyData,
})

export const setSurveyVacancyAction = (surveyVacancyData) => ({
  type: 'UI_SET_SURVEY_VACANCY_DATA',
  payload: surveyVacancyData,
})
export const setCurrentStepAction = (currentStep) => ({
  type: 'UI_SET_CURRENT_STEP',
  payload: currentStep,
})
export const setClearSurveyStatus = () => ({
  type: 'UI_CLEAR_SURVEY_STATUS',
})
